import { useTranslation } from 'react-i18next';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { useAbritrationAgreementButtonEnabled } from './helper';
import { EPLacementStatusRequirementTooltipType } from 'app/models/Placement/PlacementDetails';
import React from 'react';
import { TooltipListContent } from './utils';
export const DispatchArbitrationAgreementBtn = ({ currentPlacementStatus, existingDocuments, onClick = undefined, disabled =  false }) => {
  const { t } = useTranslation();
  const { isEnabled, tooltipContent } = useAbritrationAgreementButtonEnabled(currentPlacementStatus, existingDocuments);
  return [
    {
      title: t('placement.profile.arbitrationAgreement'),
      Icon: AssignmentOutlinedIcon,
      disabled: !isEnabled || disabled, 
      tooltipProps: {
        tooltipContent: !isEnabled ? (
          <TooltipListContent
            tooltip={{
              message: t('placement.placementStatusPickList.disabledDueTo'),
              supportingList: tooltipContent,
              tooltipType: EPLacementStatusRequirementTooltipType.messageWithSupportList,
            }}
          />
        ) : (
          t('placement.arbitrationAgreementBtn.buttonTooltip')
        ),
        disabled: false,
      },
      onClick: event => {
        onClick?.(event);
      },
    },
  ];
};
